/** Use it to notify when not all values of type or enum have been checked. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function unreachable(_x: never): never {
  throw new Error("unreachable: didn't expect to get here")
}
